/**
 * Takes the target element and returns the item-related dataset from the nearest ancestor element that has it.
 */

export default ({ target }) => {
    const component = target.dataset.hasOwnProperty("gtm-item-related") ? target : target.closest("[data-gtm-item-related]");
    const itemRelated = component?.dataset?.gtmItemRelated || "";
    return itemRelated;
}